function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#15AEFF",
  d: "M31.25 17.5h-1.875v-5.625C29.375 5.328 24.047 0 17.5 0S5.625 5.328 5.625 11.875V17.5H3.75C1.68 17.5 0 19.18 0 21.25v15C0 38.32 1.68 40 3.75 40h27.5c2.07 0 3.75-1.68 3.75-3.75v-15c0-2.07-1.68-3.75-3.75-3.75zm-8.125 0h-11.25v-5.625c0-3.102 2.523-5.625 5.625-5.625s5.625 2.523 5.625 5.625V17.5z"
});
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    fill: "none",
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1df072bc0f7955d7625554d81889d840.svg";
export { ForwardRef as ReactComponent };